<div class="gm-game gm-chess">
  <div class="gm-game-bar">
    <span class="gm-game-title">Chess</span>
    <div class="gm-game-actions">
      <button class="gm-btn" (click)="reset()">Reset</button>
    </div>
  </div>
  <div class="gm-game-body">
    <div class="ch-wrap">
      <div class="ch-status">
        <span class="ch-turn">
          <span class="ch-dotc" [style.background]="turn() === 'w' ? '#fff' : '#1a1a1a'"></span>
          {{ turn() === 'w' ? 'White' : 'Black' }} to move
        </span>
        <span class="ch-caps">
          @for (t of trayCaps(); track $index) {
            <span class="ch-pb" [style.opacity]="0.6">{{ CH_GLYPH[t] }}</span>
          }
        </span>
      </div>
      <div class="ch-board">
        @for (p of board(); track $index) {
          <div [class]="sqClass($index)" (click)="clickSq($index)">
            @if (p) {
              <span [class]="p.c === 'w' ? 'ch-pw' : 'ch-pb'">{{ CH_GLYPH[p.t] }}</span>
            }
            @if (isLegal($index)) {
              <span class="ch-dot"></span>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
